import http from '../../../utils/services/http'

export const list = (bem, limit = 100, page = 1, filtros = '') => {
    let url = `/api/bem/${bem}/videos?page=` + page + '&limit=' + limit + filtros
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const find = (bem, id) => {
    let url = `/api/bem/${bem}/videos/${id}`
    return http.get(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const newVideo = (bem, data) => {
    let url = `/api/bem/${bem}/videos`
    return http.post(url, data)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const updateVideo = (bem, video, method = 'PUT') => {
    let url = `/api/bem/${bem}/videos/${video.id}`
    let _method = http.put
    if (method === 'PATCH') {
        _method = http.patch
    }
    return _method(url, video)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}

export const deleteVideo = (bem, id) => {
    let url = `/api/bem/${bem}/videos/${id}`
    return http.delete(url)
        .then(response => {
            return Promise.resolve(response)
        })
        .catch(({response}) => {
            return Promise.reject(response)
        })
}
